import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsCancelUncancel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForCancelJob: "/api/v1/portal/jobs/cancel-job/",
      apiUrlForUncancelJob: "/api/v1/portal/jobs/uncancel-job/",
      apiUrlForUncancelJob: "/api/v1/portal/jobs/uncancel-job/",
      cancelJobReason: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  cancelJob() {
    return fetch(
      this.state.apiUrlForCancelJob+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        body: JSON.stringify({cancellation_reason: this.state.cancelJobReason}),
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json',
          "Content-Type": 'application/json',
        },
      }
    ).then((responseText) => {
      }
    );
  }
  uncancelJob() {
    return fetch(
      this.state.apiUrlForUncancelJob+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }
  cancelJobReasonData(e){
    this.setState({
        cancelJobReason: e.target.value
      });
  }

  render() {
    return(
      <span>
         {(this.state.data.status !== 'cancelled') ?
           <div className="cancel_reason_div">
           <button
             className="btn btn-lg btn-danger"
             onClick={() => {
               this.cancelJob(this.state.data.id)
             }}
           >
             <i className="fa fa-ban"></i>&nbsp;
             Cancel Job
           </button>
           <textarea name="cancellation_reason" value={this.state.cancelJobReason || ''} onChange={e => this.cancelJobReasonData(e)} placeholder="Enter Reason"></textarea>
           </div>
           :
           <div className="cancel_reason_div">
             <button
               className="btn btn-lg btn-danger"
               onClick={() => {
                 this.uncancelJob(this.state.data.id)
               }}
             >
               <i className="fa fa-circle"></i>&nbsp;
               Uncancel Job
             </button>
             <div className="cancelled_job_details">
                <p>
                  <strong>Cancelled By : </strong>
                  {(this.state.data.cancelled_by && this.state.data.cancelled_by.full_name)?this.state.data.cancelled_by.full_name:null}
                </p>
                <p>
                  <strong>Cancelled Time : </strong>
                  {this.state.data.cancelled_at}
                </p>
                <p>
                  <strong>Cancellation Reason : </strong>
                  {this.state.data.cancellation_reason}
                </p>
              </div>
            </div>
         }
    </span>
    )
  }
}